// Este archivo es un espejo de la configuración de plataformas de medios desde 'backoffice/constants/supported-platforms.ts'
export const SUPPORTED_PLATFORMS = {
  tiktok: {
    name: 'tiktok',
    match: (url: string) => /^(https?:\/\/(?:www\.)?tiktok\.com\/@[^/]+\/video\/\d+)/.test(url),
    extractId: (uri: string) => {
      const tiktokIdMatch = uri.match(/video\/(\d+)/)
      if (!tiktokIdMatch) throw new Error('Unable to extract tiktok Id')
      return tiktokIdMatch[1]
    },
  },
  instagram: {
    name: 'instagram',
    match: (url: string) => /^(https?:\/\/(?:www\.)?instagram\.com\/(?:\S+\/)?(reel|p)\/\S+)/.test(url),
    extractId: (uri: string) => {
      const instagramIdMatch = uri.match(/(?:reel|p)\/([^/]+)/)
      if (!instagramIdMatch) throw new Error('Unable to extract instagram Id')
      return instagramIdMatch[1]
    },
  },
}
